import moment from "moment";
import {isAndroid, isIOS} from "../../wenxing_h5/utils";

/**
 * 本地时间转北京时间
 * @params date 当前时间
 * @params type 转化类型
 */
export function timeToBjTime(date, type) {
  let ret = ''
  if (!date) return
  if (isIOS()) {date = date.replace(/-/g, "/")}
  let time = new Date(date);
  time.setMinutes(time.getMinutes() + new Date().getTimezoneOffset()); // 格林尼治时间
  time.setMinutes(time.getMinutes() + 480); // 北京时间
  if (!isIOS()) {
    switch (type) {
      case 'dateAll':
        ret = moment(time).format('YYYY-MM-DD HH:mm:ss')
        break;
      case 'date':
        ret = moment(time).format('YYYY-MM-DD')
        break;
      case 'hour':
        ret = moment(time).format('HH:mm:ss')
        break;
      default:
        ret = moment(time).format('YYYY-MM-DD HH:mm:ss')
        break
    }
  } else {
    switch (type) {
      case 'dateAll':
        ret = moment(time).format('YYYY/MM/DD HH:mm:ss')
        break;
      case 'date':
        ret = moment(time).format('YYYY/MM/DD')
        break;
      case 'hour':
        ret = moment(time).format('HH:mm:ss')
        break;
      default:
        ret = moment(time).format('YYYY/MM/DD HH:mm:ss')
        break
    }
  }
  

  return ret
}


/**
 * 北京时间转本地
 * @params date 当前时间
 * @params type 转化类型
 */
export function timeToLocalTime(date, type) {
  let ret = ''
  if (!date) return
  if (isIOS()) {date = date.replace(/-/g, "/")}
  let time = new Date(date);
  time.setMinutes(time.getMinutes() - 480); // 格林尼治时间
  time.setMinutes(time.getMinutes() - new Date().getTimezoneOffset()); // 本地时间

  if (!isIOS()) {
    switch (type) {
      case 'dateAll':
        ret = moment(time).format('YYYY-MM-DD HH:mm:ss')
        break;
      case 'date':
        ret = moment(time).format('YYYY-MM-DD')
        break;
      case 'hour':
        ret = moment(time).format('HH:mm:ss')
        break;
      default:
        ret = moment(time).format('YYYY-MM-DD HH:mm:ss')
        break
    }
  } else {
    switch (type) {
      case 'dateAll':
        ret = moment(time).format('YYYY/MM/DD HH:mm:ss')
        break;
      case 'date':
        ret = moment(time).format('YYYY/MM/DD')
        break;
      case 'hour':
        ret = moment(time).format('HH:mm:ss')
        break;
      default:
        ret = moment(time).format('YYYY/MM/DD HH:mm:ss')
        break
    }
  }

  return ret
}



// WEBPACK FOOTER //
// ./src/common/utils/zoneMoment.js